module.exports = {"id":"214332","name":"Daniel Torres","rating":"77","photo":"./data/images/photos/2/214332.png","club":{"name":"Deport. Alavés","logo":"./data/images/clubs/Deport.Alaves.png"},"positions":["MDC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DanielTorres0.json
// module id = 942
// module chunks = 0